import { PS20Logger } from '@ps20-frontend/logging';
import { call } from 'redux-saga/effects';
import { AnyAction } from 'redux';
import { App } from '@ps20-frontend/frontend-models';

export const safeSaga = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  saga: any,
  sourceApp: App,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handler: any = null,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ...args: any
) =>
  function* (action: AnyAction) {
    try {
      yield call(saga, ...args, action);
    } catch (err) {
      if (handler) {
        yield call(handler, ...args, err);
      } else {
        const message = `Saga error triggered by action: ${action?.type ?? 'unknown'} error message: ${err}`;
        PS20Logger.error(sourceApp, message);
      }
    }
  };
